import { render, staticRenderFns } from "./dosageProduct.html?vue&type=template&id=50b3d687&scoped=true&"
import script from "./dosageProduct.js?vue&type=script&lang=js&"
export * from "./dosageProduct.js?vue&type=script&lang=js&"
import style0 from "./dosageProduct.scss?vue&type=style&index=0&id=50b3d687&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3d687",
  null
  
)

export default component.exports